import { useEffect, useState } from 'react';
import { ReceiptText, Inbox } from 'lucide-react';
import { getHistoricoPagamentoApi } from '../../api';
import './historico.css';

const STATUS = {
    approved: { label: 'Aprovado', cls: 'is-ok' },
    pending: { label: 'Pendente', cls: 'is-pend' },
    rejected: { label: 'Recusado', cls: 'is-rej' },
};

function formatarData(iso) {
    if (!iso) return '—';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

const moeda = (v) => `R$ ${Number(v || 0).toFixed(2).replace('.', ',')}`;

export default function HistoricoPagamentos() {
    const [itens, setItens] = useState(null);

    useEffect(() => {
        let vivo = true;
        (async () => {
            try {
                const res = await getHistoricoPagamentoApi();
                if (vivo) setItens(res?.data?.data || []);
            } catch {
                if (vivo) setItens([]);
            }
        })();
        return () => { vivo = false; };
    }, []);

    return (
        <div className="ueb-page">
            <header className="ueb-page-head">
                <span className="ueb-page-ico"><ReceiptText size={22} /></span>
                <div>
                    <h1 className="ueb-page-title">Histórico de pagamentos</h1>
                    <p className="ueb-page-sub">Seus pagamentos e recibos.</p>
                </div>
            </header>

            {itens === null ? (
                <div className="pcard" style={{ padding: 40, textAlign: 'center' }}><span className="pspin" style={{ color: 'var(--p-accent)' }} /></div>
            ) : itens.length === 0 ? (
                <div className="ueb-empty pcard">
                    <span className="ueb-empty-ico"><Inbox size={28} /></span>
                    <strong>Nenhum pagamento ainda</strong>
                    <p>Quando você emitir uma carteira, os pagamentos aparecem aqui.</p>
                </div>
            ) : (
                <div className="pcard ueb-hist">
                    <table className="ueb-hist-table">
                        <thead>
                            <tr>
                                <th>Data</th><th>Produto</th><th>Valor</th><th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {itens.map((p) => {
                                const st = STATUS[p.status] || { label: p.status, cls: '' };
                                return (
                                    <tr key={p.id}>
                                        <td data-l="Data">{formatarData(p.created_at)}</td>
                                        <td data-l="Produto">
                                            <strong>{p.product_title || '—'}</strong>
                                            <small className="pfaint"> · {p.product_ano}</small>
                                        </td>
                                        <td data-l="Valor">{moeda(p.amount)}</td>
                                        <td data-l="Status"><span className={`ueb-hist-badge ${st.cls}`}>{st.label}</span></td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
